export const DATE_FORMAT_DATE_TIME = 'MMM d, yyyy @ h:mma'; // Jul 16 @ 7:50am
export const DATE_FORMAT_DATE_TIMEZONE = 'MMM d, yyyy @ h:mma zzz'; // Jul 16 @ 7:50am EST
export const DATE_FORMAT_DAY = 'yyyy-MM-dd'; // 2020-07-16
export const DATE_FORMAT_PICKER = 'yyyy-MM-dd h:mma'; // 2020-07-16 11:11am
export const DATE_MINIMUM = '2000-01-01'; // set a minimum for date selectors so you can't go back to the 1800s ;)
export const PLACEHOLDER_EMPTY = '-';

export const TIMEZONE = 'America/New_York';
export const TIMEZONE_ABBR = 'ET';
